<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import AppSwitcher from "#lib/components/flow/viewer/desktop/AppSwitcher.svelte";
	import type { AppSwitcherLayoutProps } from "#lib/components/flow/viewer/types.js";

	const { apps, maxVisibleModules, metadata, readOnly = false, interpolate = false, mode = Mode.LIVE, layoutName, themeStyle, isLightBackground, accessory, class: className, classes, onExecute, onCancel, onShow }: AppSwitcherLayoutProps = $props();
</script>

<div class={twMerge("mx-auto flex max-w-215 flex-col gap-3 px-6 pb-8", className)}>
	{#if apps.length > 2}
		<div class="grid w-full grid-cols-3 gap-6">
			{#each apps.slice(0, maxVisibleModules || apps.length) as page, i (page.key)}
				<div class="relative">
					<AppSwitcher {metadata} {layoutName} {themeStyle} {isLightBackground} {onExecute} {onCancel} {page} {onShow} {mode} {readOnly} {interpolate} {classes} />
					{@render accessory?.(i)}
				</div>
			{/each}
		</div>
	{:else}
		<div class={apps.length === 1 ? "mx-auto flex w-100 flex-row items-center" : "grid w-full grid-cols-2 gap-6"}>
			{#each apps.slice(apps.length - (apps.length % 3), apps.length) as page (page.key)}
				<AppSwitcher {metadata} {layoutName} {themeStyle} {isLightBackground} {onExecute} {onCancel} {page} {onShow} {mode} {readOnly} {interpolate} {classes} />
			{/each}
		</div>
	{/if}
</div>
